class PaginationWrapper extends HTMLElement {
  constructor() {
    super();
  }

  updatePagination() {
    this.paginationNext = this.querySelector(".next");
    this.paginationPrev = this.querySelector(".prev");

    this.paginationPrevLink = this.paginationPrev?.querySelector("a");
    this.paginationNextLink = this.paginationNext?.querySelector("a");

    this.paginationPrevLink?.setAttribute("rel", "prev");
    this.paginationNextLink?.setAttribute("rel", "next");
  }

  connectedCallback() {
    this.updatePagination();
  }
}

customElements.define("pagination-wrapper", PaginationWrapper);